import { put, takeLatest } from "redux-saga/effects";
import { types } from "../action_types";
import { GET, POST, PUT } from "../../Utils/httpServices";
import CustomToster from "../../SharedComponents/CustomToaster";

const getToken = () => window.sessionStorage.getItem("token");

function* GetSeasonsSaga({ payload }) {
  try {
    const { page = 1, limit = 20 } = payload || {};
    const response = yield GET(`admin/seasons?page=${page}&limit=${limit}`, {
      headers: { Authorization: `Bearer ${getToken()}` },
    });

    if (response?.status === 200) {
      yield put({
        type: types.GetSeasonsRequestSuccess,
        payload: response?.data?.data,
      });
    } else {
      yield put({ type: types.GetSeasonsRequestFailure });
    }
  } catch (e) {
    CustomToster({ type: "error", message: e?.response?.data?.message || e?.response?.data?.error?.message || e?.message });
    yield put({ type: types.GetSeasonsRequestFailure });
  }
}

function* CreateSeasonSaga({ payload }) {
  try {
    const response = yield POST("admin/seasons", payload, {
      headers: { Authorization: `Bearer ${getToken()}` },
    });

    if (response?.status === 200 || response?.status === 201) {
      yield put({ type: types.CreateSeasonRequestSuccess, payload: response?.data?.data });
      CustomToster({ type: "success", message: "Season created successfully" });
      yield put({ type: types.GetSeasonsRequest, payload: { page: 1 } });
    } else {
      yield put({ type: types.CreateSeasonRequestFailure });
    }
  } catch (e) {
    CustomToster({ type: "error", message: e?.response?.data?.message || e?.response?.data?.error?.message || e?.message });
    yield put({ type: types.CreateSeasonRequestFailure });
  }
}

function* UpdateSeasonSaga({ payload }) {
  try {
    const { id, ...data } = payload;
    const response = yield PUT(`admin/seasons/${id}`, data, {
      headers: { Authorization: `Bearer ${getToken()}` },
    });

    if (response?.status === 200) {
      yield put({ type: types.UpdateSeasonRequestSuccess, payload: response?.data?.data });
      CustomToster({ type: "success", message: "Season updated successfully" });
      yield put({ type: types.GetSeasonsRequest, payload: { page: 1 } });
    } else {
      yield put({ type: types.UpdateSeasonRequestFailure });
    }
  } catch (e) {
    CustomToster({ type: "error", message: e?.response?.data?.message || e?.response?.data?.error?.message || e?.message });
    yield put({ type: types.UpdateSeasonRequestFailure });
  }
}

export default function* SeasonsSaga() {
  yield takeLatest(types.GetSeasonsRequest, GetSeasonsSaga);
  yield takeLatest(types.CreateSeasonRequest, CreateSeasonSaga);
  yield takeLatest(types.UpdateSeasonRequest, UpdateSeasonSaga);
}
